import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../dto/dto.js';
import { Price } from './price.js';

export class PoolPricingSettings extends DataModel {
  static readonly TYPE_ID: string = '81cd7cd91ba94a1189559669a6644c47';

  constructor(
        public readonly adultServicePrice: Price,
        public readonly studentServicePrice: Price,
        public readonly pensionerServicePrice: Price,
        public readonly familyServicePrice: Price,
  ) {
    super();
  }

  get $typeId(): string {
    return PoolPricingSettings.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): PoolPricingSettings {
    return new PoolPricingSettings(
        Price.decode(MapUtils.get<string>(map, 'adultServicePrice')),
        Price.decode(MapUtils.get<string>(map, 'studentServicePrice')),
        Price.decode(MapUtils.get<string>(map, 'pensionerServicePrice')),
        Price.decode(MapUtils.get<string>(map, 'familyServicePrice')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'adultServicePrice': this.adultServicePrice.encode(),
      'studentServicePrice': this.studentServicePrice.encode(),
      'pensionerServicePrice': this.pensionerServicePrice.encode(),
      'familyServicePrice': this.familyServicePrice.encode(),
    };
  }

  clone(): this {
    return new PoolPricingSettings(
        this.adultServicePrice.clone(),
        this.studentServicePrice.clone(),
        this.pensionerServicePrice.clone(),
        this.familyServicePrice.clone(),
    ) as this;
  }

  isSame(other: PoolPricingSettings): boolean {
    if(this === other) {
      return true;
    }

    return isSameData(other.adultServicePrice, this.adultServicePrice) &&
            isSameData(other.studentServicePrice, this.studentServicePrice) &&
            isSameData(other.pensionerServicePrice, this.pensionerServicePrice) &&
            isSameData(other.familyServicePrice, this.familyServicePrice);
  }
}

export class PoolPricingSettingsBuilder extends DataModelBuilder<PoolPricingSettings> {
  build(context: SerializationContext, map: SerializedData): PoolPricingSettings {
    return PoolPricingSettings.fromMap(context, map);
  }
}
